import apiClient from './apiClient';

// Καθήκοντα (ΛΑ-18, ΛΑ-19, ΛΑ-20).
//
// **Δικό του module** και όχι νέες μέθοδοι στο `auth.service.js`: εκείνο ανήκει στο
// P1-5 κατά τον κανόνα ιδιοκτησίας των παράλληλων κλάδων, και δύο κλάδοι που
// προσθέτουν μεθόδους στο ίδιο αρχείο συγκρούονται στην ίδια περιοχή. Νέο αρχείο
// δεν συγκρούεται ποτέ. Ο μεταφορέας παραμένει ο υπάρχων `apiClient`.
//
// **Ο κατάλογος ζητείται πάντοτε ανά συλλογή**, γιατί εκεί ζει το καθήκον: το
// §4.3.4 το ορίζει ως «μονάδα εργασίας εντός συλλογής». Οι διαδρομές του
// μεμονωμένου καθηκόντος δεν φέρουν συλλογή — την **παράγει ο εξυπηρετητής** από
// το ίδιο το καθήκον, και εκεί γίνεται ο έλεγχος δικαιωμάτων.

function assertCollection(collectionId) {
    if (!collectionId) {
        throw new Error('Τα καθήκοντα είναι ανά συλλογή: λείπει το αναγνωριστικό συλλογής.');
    }
}

export function getTasks(collectionId, { status } = {}) {
    assertCollection(collectionId);
    const query = status ? `?status=${encodeURIComponent(status)}` : '';
    return apiClient.getPage(`/api/collections/${collectionId}/tasks${query}`);
}

/** ΛΑ-18. Ενέργεια συντονιστή· ο εξυπηρετητής το επιβάλλει. */
export function createTask(collectionId, task) {
    assertCollection(collectionId);
    return apiClient.post(`/api/collections/${collectionId}/tasks`, task);
}

/**
 * ΛΑ-19 και ΛΑ-20. Στέλνονται **μόνο** τα πεδία που αλλάζουν.
 *
 * Δεν είναι οικονομία bytes: η διαδρομή έχει δύο επίπεδα δικαιώματος — ο ανάδοχος
 * αλλάζει κατάσταση, ο συντονιστής τα πάντα — και ένα αίτημα που στέλνει ολόκληρο
 * το καθήκον θα ζητούσε από τον ανάδοχο δικαίωμα διαχείρισης για να αλλάξει την
 * κατάστασή του. Το σχήμα ενημέρωσης είναι επιπλέον `.strict()`: άγνωστο πεδίο
 * απορρίπτεται με 422 αντί να αγνοηθεί.
 */
export function updateTask(taskId, changes) {
    return apiClient.patch(`/api/tasks/${taskId}`, changes);
}

/**
 * ΛΑ-20, **Απόφαση D29**: τα καθήκοντα σε **όλες τις ορατές συλλογές**.
 *
 * Νέα διαδρομή εκτός του πίνακα του §4.5.1, με το προηγούμενο της διασυλλογικής
 * αναζήτησης πόρων και τον ίδιο λόγο: ο **ανάδοχος** δεν είναι ιδιότητα της
 * συλλογής αλλά πρόσωπο, και το πρόσωπο συμμετέχει σε πολλές.
 *
 * **Καμία δεύτερη κλήση για τον κατάλογο του επιλογέα.** Οι συλλογές έρχονται
 * στο `meta` της ίδιας απόκρισης, παραγόμενες από το **ίδιο** φίλτρο ορατότητας:
 * ένωση των δύο ευρών του καταλόγου συλλογών στον πελάτη θα ήταν τρίτη
 * διατύπωση του κανόνα του Πίνακα 1.
 */
export function getVisibleTasks({ collection, status } = {}) {
    const params = new URLSearchParams();
    if (collection) params.set('collection', collection);
    if (status) params.set('status', status);

    const query = params.toString();
    return apiClient.getPage(`/api/tasks${query ? `?${query}` : ''}`);
}

export function deleteTask(taskId) {
    return apiClient.del(`/api/tasks/${taskId}`);
}

/** ΛΑ-20: «να καταγράφουν παρατηρήσεις σχετικά με την πρόοδό τους». */
export function addNote(taskId, text) {
    return apiClient.post(`/api/tasks/${taskId}/notes`, { text });
}

export default { getTasks, getVisibleTasks, createTask, updateTask, deleteTask, addNote };
